import { render, staticRenderFns } from "./EditBridge.vue?vue&type=template&id=e5296190&scoped=true&"
import script from "./EditBridge.vue?vue&type=script&lang=js&"
export * from "./EditBridge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5296190",
  null
  
)

export default component.exports